import { register } from "../../../JavaScript/Utils";

export const BlogListingSelect = (el: HTMLElement) => {
  const currentUrl: string = window.location.href;
  const postListElement: HTMLElement = document.querySelector("#blogPostList");

  const divForBlogListingSelect: HTMLElement = el.querySelector(
    ".comp-blog-listing-select"
  );

  const divForBlogListingSelect__current: HTMLElement = el.querySelector(
    ".comp-blog-listing-select-current"
  );

  const linkForAllCategories: HTMLElement = el.querySelector(".blogStart")

  if (!currentUrl.includes("kategorie")) {
    linkForAllCategories.parentElement.style.display = "none"
  }

    if (window.location.hash === "#postlist") {
      if (postListElement) {
        postListElement.parentElement?.scrollIntoView();
      }
    }
    divForBlogListingSelect.addEventListener("click", () => {
      divForBlogListingSelect__current.classList.toggle("is-active");
    });
};

register("BlogListingSelect", BlogListingSelect);
